/**
 * TanStack Query hooks for `row-actions-menu-edit-pause-duplicate-delete`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	rowActionsMenuEditPauseDuplicateDeleteQueryKeys,
	type CreateRowActionsMenuEditPauseDuplicateDeleteBody,
	type ListRowActionsMenuEditPauseDuplicateDeleteResponse,
	type RowActionsMenuEditPauseDuplicateDeleteRow,
} from "./api";

export function useRowActionsMenuEditPauseDuplicateDeleteList(): UseQueryResult<ListRowActionsMenuEditPauseDuplicateDeleteResponse, Error> {
	return useQuery({
		queryKey: rowActionsMenuEditPauseDuplicateDeleteQueryKeys.list(),
		queryFn: list,
	});
}

export function useRowActionsMenuEditPauseDuplicateDeleteCreate(): UseMutationResult<RowActionsMenuEditPauseDuplicateDeleteRow, Error, CreateRowActionsMenuEditPauseDuplicateDeleteBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: rowActionsMenuEditPauseDuplicateDeleteQueryKeys.all });
		},
	});
}

export function useRowActionsMenuEditPauseDuplicateDeleteDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: rowActionsMenuEditPauseDuplicateDeleteQueryKeys.all });
		},
	});
}
